/* ==========================================================================
   how-layaway-works.js — one road, three uses.

   The hero draws the plan once, large, through the four stops; the story
   drives the plan card beside Maria's beats; the comparison draws the same
   road three times at three lengths. All dates are LaybyClock's, all
   in-card roads are LaybyRoad's, so nothing here can disagree with the
   checkout or the account.
   ========================================================================== */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var INK = '#142B52';
  var ORANGE = '#F26A21';
  var MUTED = '#6A625A';
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function el(name, attrs) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]);
    return n;
  }
  function clear(svg) { while (svg.firstChild) svg.removeChild(svg.firstChild); }
  function line(x1, y1, x2, y2, extra) {
    var a = { x1: x1, y1: y1, x2: x2, y2: y2, stroke: INK, 'stroke-width': 2, 'stroke-linecap': 'round' };
    for (var k in extra) if (extra.hasOwnProperty(k)) a[k] = extra[k];
    return el('line', a);
  }
  function flagH(x, y, color) {
    var g = el('g', {});
    g.appendChild(el('path', { d: 'M' + x + ' ' + (y - 24) + ' v24', stroke: color, 'stroke-width': 2, 'stroke-linecap': 'round' }));
    g.appendChild(el('path', { d: 'M' + (x + 1) + ' ' + (y - 24) + ' h13 l-4 5 4 5 h-13z', fill: color }));
    return g;
  }
  function doorH(x, y, color) {
    var g = el('g', {});
    g.appendChild(el('rect', { x: x - 6, y: y - 13, width: 12, height: 26, rx: 1.5, fill: 'none', stroke: color, 'stroke-width': 2 }));
    g.appendChild(el('circle', { cx: x + 3, cy: y + 1, r: 1.4, fill: color }));
    return g;
  }

  /* Reveal a freshly drawn road left to right (or top to bottom). Each part
     carries its own delay from its position; the class flips on the next
     frame so the transition runs. Later redraws (a resize) show at once. */
  function reveal(svg, parts, extent, animate) {
    parts.forEach(function (p) {
      p.node.style.transitionDelay = animate && !reduce ? Math.round((p.at / extent) * 900) + 'ms' : '0ms';
      svg.appendChild(p.node);
    });
    if (!animate || reduce) { svg.classList.add('is-drawn'); return; }
    svg.classList.remove('is-drawn');
    void svg.getBoundingClientRect();
    requestAnimationFrame(function () { requestAnimationFrame(function () { svg.classList.add('is-drawn'); }); });
  }

  /* ------------------------------------------------------------ the hero road */

  // stops as fractions of the road box, matching the --x on the stops
  var STOPS = { box: 0.09, cal: 0.30, flag: 0.83, door: 0.90 };

  function drawHeroH(svg, animate) {
    var W = Math.round(svg.clientWidth);
    if (!W) return;
    var Y = 32;
    clear(svg);
    svg.setAttribute('viewBox', '0 0 ' + W + ' 64');
    svg.setAttribute('preserveAspectRatio', 'xMinYMid meet');

    var xb = W * STOPS.box, xc = W * STOPS.cal, xf = W * STOPS.flag, xd = W * STOPS.door;
    var parts = [];

    // pick → start: dotted, the way the homepage joins its drawings. Both
    // happen today; the orange dot at the start is the first payment.
    parts.push({ at: xb, node: line(xb, Y, xc - 12, Y, { 'stroke-width': 3, 'stroke-dasharray': '0 9', opacity: 0.9 }) });

    // the road
    parts.push({ at: xc, node: line(xc, Y, xf, Y, { 'stroke-width': 2.2 }) });
    var n = Math.max(8, Math.round((xf - xc) / 28));
    for (var i = 1; i < n; i++) {
      var x = xc + (xf - xc) * (i / n);
      parts.push({ at: x, node: line(x, Y - 5, x, Y + 5) });
    }
    [0.25, 0.5, 0.75].forEach(function (f) {
      var qx = xc + (xf - xc) * f;
      parts.push({ at: qx, node: line(qx, Y - 14, qx, Y - 11, { 'stroke-width': 1.5, opacity: 0.55 }) });
    });
    parts.push({ at: xc, node: el('circle', { cx: xc, cy: Y, r: 5.5, fill: ORANGE }) });
    parts.push({ at: xf, node: flagH(xf, Y, INK) });
    parts.push({ at: xf + 16, node: line(xf + 16, Y, xd - 6, Y, { stroke: MUTED, 'stroke-dasharray': '3 4' }) });

    reveal(svg, parts, W, animate);
  }

  // The same grammar, turned: the line runs down beside the stops. Marks
  // sit at the measured centres of the rows, so they always line up.
  function drawHeroV(svg, ys, animate) {
    var H = Math.round(ys.height);
    if (!H) return;
    var X = 22;
    clear(svg);
    svg.setAttribute('viewBox', '0 0 44 ' + H);
    svg.setAttribute('height', H);
    svg.setAttribute('preserveAspectRatio', 'xMidYMin meet');

    var parts = [];
    parts.push({ at: ys.box, node: line(X, ys.box, X, ys.cal - 12, { 'stroke-width': 3, 'stroke-dasharray': '0 9', opacity: 0.9 }) });
    parts.push({ at: ys.cal, node: line(X, ys.cal, X, ys.flag, { 'stroke-width': 2.2 }) });
    var n = Math.max(6, Math.round((ys.flag - ys.cal) / 24));
    for (var i = 1; i < n; i++) {
      var y = ys.cal + (ys.flag - ys.cal) * (i / n);
      parts.push({ at: y, node: line(X - 5, y, X + 5, y) });
    }
    parts.push({ at: ys.cal, node: el('circle', { cx: X, cy: ys.cal, r: 5.5, fill: ORANGE }) });
    // payoff: a wider bar, and the pennant flying off the road itself
    parts.push({ at: ys.flag, node: line(X - 9, ys.flag, X + 9, ys.flag, { 'stroke-width': 2.4 }) });
    parts.push({ at: ys.flag, node: el('path', { d: 'M' + (X + 1) + ' ' + (ys.flag - 26) + ' h13 l-4 5 4 5 h-13z', fill: INK }) });
    parts.push({ at: ys.flag, node: line(X, ys.flag - 26, X, ys.flag, { 'stroke-width': 2.2 }) });
    parts.push({ at: ys.flag + 12, node: line(X, ys.flag + 12, X, ys.door - 8, { stroke: MUTED, 'stroke-dasharray': '3 4' }) });

    reveal(svg, parts, H, animate);
  }

  function hero(root) {
    var fig = root.querySelector('[data-hero]');
    if (!fig) return;
    var h = fig.querySelector('[data-hero-road]');
    var v = fig.querySelector('[data-hero-road-v]');
    var rows = fig.querySelector('[data-rows]');
    var drawnH = false, drawnV = false;

    function redraw() {
      if (h && h.clientWidth) { drawHeroH(h, !drawnH); drawnH = true; }
      if (v && v.clientWidth && rows) {
        var r = rows.getBoundingClientRect();
        var items = rows.querySelectorAll('[data-row]');
        if (items.length < 4) return;
        var c = function (i) { var b = items[i].getBoundingClientRect(); return b.top - r.top + b.height / 2; };
        var payBottom = items[2].getBoundingClientRect().bottom - r.top;
        drawHeroV(v, { height: r.height, box: c(0), cal: c(1), flag: payBottom - 2, door: c(3) }, !drawnV);
        drawnV = true;
      }
    }

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(redraw).observe(fig);
    } else {
      redraw();
      window.addEventListener('resize', redraw);
    }
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(redraw).catch(function () {});
    }
  }

  /* ------------------------------------------------------------ the story */

  function story(root, clock, road) {
    var s = root.querySelector('[data-story]');
    if (!s) return;

    var price = parseInt(s.dataset.price, 10) || 500;
    var weekly = parseInt(s.dataset.weekly, 10) || 25;
    var payday = parseInt(s.dataset.payday, 10) || 5;
    var bumpAfter = parseInt(s.dataset.bumpAfter, 10) || 8;
    var bumpTo = parseInt(s.dataset.bumpTo, 10) || 50;
    var skipAt = parseInt(s.dataset.skipAt, 10) || 10;

    // Her first payment is today, when she places the order; payment 1 is a
    // week later on the same weekday, and every later one a week after that.
    // There is no payday to pick (2026-10-13): her payday is the day she
    // starts it, so the story names that day, not the section's setting.
    var dates = { from: clock.orderDay() };
    var pay = function (i) { return clock.paymentDate(i, dates); };
    var first = pay(0), next = pay(1);
    payday = next.getDay();
    var n = Math.max(1, Math.ceil(price / weekly));
    bumpAfter = Math.min(bumpAfter, n - 1);
    var rest = Math.max(1, Math.ceil((price - bumpAfter * weekly) / bumpTo));
    var nBump = bumpAfter + rest;                 // payments once she pays more
    skipAt = Math.max(bumpAfter + 1, Math.min(skipAt, nBump - 1));
    var nFinal = nBump + 1;                        // slots, one of them the break
    var last = pay(n - 1), lastBump = pay(nBump - 1), lastFinal = pay(nFinal - 1);
    var sooner = n - nBump;

    var tokens = {
      first: clock.fmtDay(first),
      next: clock.fmtDay(next),
      last: clock.fmt(last),
      last_bump: clock.fmt(lastBump),
      last_final: clock.fmt(lastFinal),
      bump_date: clock.fmtDay(pay(bumpAfter)),
      skip_date: clock.fmtDay(pay(skipAt)),
      sooner: String(sooner),
      n: String(n),
      n_final: String(nBump),
      payday: DAY_NAMES[payday]
    };
    s.querySelectorAll('[data-t]').forEach(function (e) {
      var k = e.dataset.t;
      if (tokens[k] != null) e.textContent = tokens[k];
    });

    var money = clock.money;
    // "today" is her first payment, made as she orders; "first" is her next
    // payday, when the second one comes out.
    var states = {
      today: { big: money(weekly) + ' today', note: n + ' payments of ' + money(weekly) + ': today, then every ' + DAY_NAMES[payday] + ' from ' + clock.fmt(next) + '.', payments: n, paid: 1, last: last },
      first: { big: money(weekly * Math.min(2, n)) + ' paid', note: Math.max(0, n - 2) + ' to go, one a week.', payments: n, paid: Math.min(2, n), last: last },
      bump:  { big: money(bumpTo) + ' a week now', note: 'Paid off ' + sooner + ' weeks sooner.', payments: nBump, paid: bumpAfter, last: lastBump },
      skip:  { big: 'One week off', note: 'No fee. Paid off ' + clock.fmt(lastFinal) + ' instead.', payments: nFinal, paid: skipAt + 1, skipAt: skipAt, last: lastFinal },
      paid:  { big: 'Paid in full', note: money(price) + ' paid. No interest, nothing extra.', payments: nFinal, paid: nFinal, skipAt: skipAt, last: lastFinal, flagLit: true },
      ships: { big: 'On its way', note: 'Ships free, with tracking.', payments: nFinal, paid: nFinal, skipAt: skipAt, last: lastFinal, flagLit: true, doorLit: true }
    };

    var card = s.querySelector('[data-card]');
    if (!card) return;
    var out = {
      big: card.querySelector('[data-card-big]'),
      note: card.querySelector('[data-card-note]'),
      first: card.querySelector('[data-card-first]'),
      last: card.querySelector('[data-card-last]'),
      road: card.querySelector('[data-road]')
    };
    var current = states.today;

    function roadOpts() {
      return {
        payments: current.payments,
        paid: current.paid,
        skipAt: current.skipAt == null ? null : current.skipAt,
        flagLit: !!current.flagLit,
        doorLit: !!current.doorLit
      };
    }

    function paint() {
      if (out.big) out.big.textContent = current.big;
      if (out.note) out.note.textContent = current.note;
      if (out.first) out.first.textContent = 'Today';
      if (out.last) out.last.textContent = clock.fmt(current.last);
      if (out.road && road) road.draw(out.road, roadOpts());
    }

    var switching;
    function apply(st) {
      if (st === current) return;
      current = st;
      if (reduce) { paint(); return; }
      card.classList.add('is-switching');
      clearTimeout(switching);
      switching = setTimeout(function () { paint(); card.classList.remove('is-switching'); }, 140);
    }

    if (out.road && road) road.register(out.road, roadOpts);
    paint();

    var beats = Array.prototype.slice.call(s.querySelectorAll('[data-beat]'));
    function activate(beat) {
      beats.forEach(function (b) { b.classList.toggle('is-active', b === beat); });
      apply(states[beat.dataset.beat] || states.today);
    }
    if (!beats.length) return;
    activate(beats[0]);

    beats.forEach(function (b) {
      b.addEventListener('click', function () { activate(b); });
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(b); } });
    });

    // The beat crossing the middle of the screen is the one the card answers.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var hit = null;
        entries.forEach(function (en) { if (en.isIntersecting) hit = en.target; });
        if (hit) activate(hit);
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
      beats.forEach(function (b) { io.observe(b); });
    }
  }

  /* ------------------------------------------------------------ three ways */

  function ways(root) {
    var list = root.querySelector('[data-ways]');
    if (!list) return;
    var max = parseFloat(list.dataset.max) || 1;
    var drawn = false;

    function draw() {
      var animate = !drawn;
      drawn = true;
      list.querySelectorAll('[data-way]').forEach(function (w) {
        var svg = w.querySelector('[data-way-road]');
        if (!svg) return;
        var W = Math.round(svg.clientWidth);
        if (!W) return;
        var total = parseFloat(w.dataset.total) || 0;
        var doorAt = w.dataset.door === 'start' ? 'start' : 'end';
        var tail = w.dataset.tail === 'true';
        var Y = 20;
        clear(svg);
        svg.setAttribute('viewBox', '0 0 ' + W + ' 40');
        svg.setAttribute('preserveAspectRatio', 'xMinYMid meet');

        var parts = [];
        var x0 = 8;
        var room = W - 16 - 76;                      // the flag, the bracket and the door at the end
        var len = Math.max(40, room * (total / max));

        if (doorAt === 'start') { parts.push({ at: x0, node: doorH(x0 + 6, Y, INK) }); x0 += 26; }
        var x1 = x0 + len;
        parts.push({ at: x0, node: line(x0, Y, x1, Y, { 'stroke-width': 2.2 }) });
        for (var x = x0 + 12; x < x1 - 4; x += 12) parts.push({ at: x, node: line(x, Y - 5, x, Y + 5) });
        parts.push({ at: x0, node: el('circle', { cx: x0, cy: Y, r: 5, fill: ORANGE }) });

        if (doorAt === 'end') {
          parts.push({ at: x1, node: flagH(x1, Y, INK) });
          parts.push({ at: x1 + 16, node: line(x1 + 16, Y, x1 + 52, Y, { stroke: MUTED, 'stroke-dasharray': '3 4' }) });
          parts.push({ at: x1 + 60, node: doorH(x1 + 60, Y, INK) });
        } else if (tail) {
          parts.push({ at: x1 + 8, node: line(x1 + 8, Y, Math.min(W - 8, x1 + 8 + room * 0.16), Y, { stroke: MUTED, 'stroke-dasharray': '3 4' }) });
        }
        reveal(svg, parts, W, animate);
      });
    }

    if (typeof ResizeObserver === 'function') new ResizeObserver(draw).observe(list);
    else { draw(); window.addEventListener('resize', draw); }
  }

  /* ------------------------------------------------------------ the sticky header's height */

  function trackHeader(root) {
    var header = document.querySelector('[is="sticky-header"]') || document.querySelector('.header-section');
    if (!header) return;
    var ticking = false;
    function set() {
      ticking = false;
      var b = header.getBoundingClientRect().bottom;
      root.style.setProperty('--hlw-top', Math.max(0, Math.round(b)) + 'px');
    }
    set();
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(set);
    }, { passive: true });
    window.addEventListener('resize', set);
  }

  /* ------------------------------------------------------------ boot */

  function boot() {
    var clock = window.LaybyClock, road = window.LaybyRoad;
    document.querySelectorAll('[data-hlw]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      hero(root);
      if (clock && road) story(root, clock, road);
      ways(root);
      trackHeader(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
